import { combineReducers } from 'redux'
import KeplerConfigReducer from './KeplerConfigReducer'
import { MyKeplerGlReducer } from './MyKeplerGlReducer'

export const MapReducer = combineReducers({
    keplerConfig: KeplerConfigReducer,
    keplerGl: MyKeplerGlReducer
})